import SetColor from '@/views/readTreasure/components/setColor/index.jsx'
import React from 'react'
import { message } from 'antd'

export default function OfficialAccount(props) {
  return (<React.Fragment>
    <div className='main_Box'>
      <h3 className='box_title'>已关联的公众号</h3>
      <div className='boxMain'>
        <div className='item'>
          <span className='item_text'>...</span>
        </div>
      </div>
    </div>

    <div className='main_Box'>
      <div className='boxMain'>
        <div className='item'>
          <button className={`switch ${props.typeItem.isFollow ? 'active' : ''}`} onClick={() => {

          }}>
            <i className={`switch_icon`} onClick={() => {
              props.mySetIfon && props.mySetIfon({
                ...props.typeItem,
                isFollow: !props.typeItem.isFollow
              })
            }}></i>
          </button>
          <h3 className='item_mytitle'>一键关注</h3>
        </div>
      </div>
    </div>

    <div className='main_Box'>
      <h3 className='box_title'>按钮外观</h3>
      <div className='boxMain'>
        <div className='item'>
          <span className='item_title'>按钮文案</span>
          <div className='item_main'>
            <div className='mainInputBox'>
              <input className='input' value={props.typeItem.title} onChange={(e) => {
                props.mySetIfon && props.mySetIfon({
                  ...props.typeItem,
                  title: e.target.value
                })
              }} onBlur={(e) => {
                if (e.target.value.length > 5) {
                  message.warning('按钮文案长度不能大于5')
                  props.mySetIfon({
                    ...props.typeItem,
                    title: e.target.value.slice(0, 5)
                  })
                }
              }}/>
              <span className='input_text'>{props.typeItem.title.length}/5</span>
            </div>
            <div className='mainButtonBox'>
              <button className={`button ${props.typeItem.text_alignment === 0 ? 'active' : ''}`} onClick={() => {
                props.typeItem.text_alignment !== 0 && props.mySetIfon && props.mySetIfon({
                  ...props.typeItem,
                  text_alignment: 0
                })
              }}>常规</button>
              <button className={`button ${props.typeItem.text_alignment === 1 ? 'active' : ''}`} onClick={() => {
                props.typeItem.text_alignment !== 1 && props.mySetIfon && props.mySetIfon({
                  ...props.typeItem,
                  text_alignment: 1
                })
              }}>加粗</button>
            </div>
          </div>
        </div>

        <div className='boMain'>
          <div className='item'>
            <span className='item_title'>字体色</span>
            <div className='item_main'>
              <SetColor color={props.typeItem.font_color} setColor={(obj) => {
                props.mySetIfon && props.mySetIfon({
                  ...props.typeItem,
                  font_color: obj.hex
                })
              }}></SetColor>
            </div>
          </div>
        </div>

        <div className='boMain'>
          <div className='item'>
            <span className='item_title'>填充色</span>
            <div className='item_main'>
              <SetColor color={props.typeItem.bg_color} setColor={(obj) => {
                props.mySetIfon && props.mySetIfon({
                  ...props.typeItem,
                  bg_color: obj.hex
                })
              }}></SetColor>
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>)
}
